import axios from 'axios';
import i18next from 'i18next';
import { PAIDIT_API, TIMEZONE } from '../config';
import paiditSuccess from '../interceptors/paidit-sucess';
import paiditError from '../interceptors/paidit-error';
import paiditRequests from '../interceptors/paidit-requests';

export const RELOAD = 'RELOAD';
export const POPUP = 'POPUP';

const DEFAULT_API_CONFIG = {
    alertError: {
        type: POPUP
    },
    rejectOnError: true,
    trackLoading: true
};
const instance = axios.create({
    baseURL: PAIDIT_API,
    timeout: 12000,
});

instance.interceptors.request.use(paiditRequests);
instance.interceptors.response.use(paiditSuccess, paiditError);

export default (config = {}) => {
    const headers = { timezone: TIMEZONE, language: i18next.language };
    const apiConfig = { ...DEFAULT_API_CONFIG, ...config };
    const axiosConfig = { headers, apiConfig };

    return {
        setup: (chainId, websiteAccessKey) => instance.get(`setup/${chainId}?wak=${websiteAccessKey || ''}`, axiosConfig),
        delivery: {
            getEligbleRestaurants: (location, ownerId) => instance.post('delivery/eligble-restaurants', { location, filterOptions: { ownerId } }, axiosConfig),
        },
        chain: {
            fetchBranches: (chainId, orderType) => instance.get(`chains/${chainId}/branches?orderType=${orderType}`, axiosConfig)
        },
        payment: {
            generateSecurePayment: (branchId, checkoutData) => instance.post(`payment/generate`, { branchId, checkoutData }, axiosConfig),            
        },
        order: {
            start: branchId => instance.post('orders/create', { branchId }, axiosConfig),
            validate: order => instance.post('orders/validate', order, { ...axiosConfig, timeout: 15000 }),
            checkout: order => instance.post('orders/checkout', order, { ...axiosConfig, timeout: 30000 }),
            confirmation: orderGuid => instance.get(`order-confirmation/${orderGuid}`, axiosConfig),
            getUpsells: (branchId, type, data, cartId) => instance.post(`orders/upsells`, { branchId, cartId, trigger: { type, data } }, axiosConfig),
        },
        google: {
            locationAutocomplete: (input, locale) => instance.get(`google/autocomplete?input=${input}&locale=${locale}`, axiosConfig),
            locationDetails: (placeId, locale) => instance.get(`google/locationDetails?placeId=${placeId}&fields=name,address_component,alt_id,formatted_address,type,geometry&language=${locale}`, axiosConfig),
        }
    };
};